var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{attrs:{"color":_vm.getStatusColor(_vm.status)},on:{"click":_vm.statusClick}},[(_vm.showIcon)?_c('a-icon',{staticStyle:{"color":"red"},attrs:{"type":"info-circle"}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.getStatusName(_vm.status))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }